/**
 * @generated SignedSource<<6b9ce164651bb65c40595304aa1a147e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksArticlePageFloatingButtonConfigArticle$data = {
  readonly floatingButtonConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "hooksArticlePageFloatingButtonConfigArticle";
};
export type hooksArticlePageFloatingButtonConfigArticle$key = {
  readonly " $data"?: hooksArticlePageFloatingButtonConfigArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksArticlePageFloatingButtonConfigArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksArticlePageFloatingButtonConfigArticle",
  "selections": [
    {
      "alias": "floatingButtonConfig",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "article_floating_button"
          }
        }
      ],
      "concreteType": "AppConfigs",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "json",
          "storageKey": null
        }
      ],
      "storageKey": "appConfig(filter:{\"entityId\":\"article_floating_button\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "41506666cc6ecfdfce2ea6055abf52a2";

export default node;
